/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  DescriptionRunResultDTO,
  PaginatedDescriptionRunEventsDTO,
  PaginatedDescriptionRunsDTO,
  PlatformDescriptionStatusDTO,
  ProductDescriptionSettingsDTO,
  RegeneratedDescriptionDTO,
  ToggleProductDescriptionEnabledDTO
} from "../models";
import {
  DescriptionRunResultDTOFromJSON,
  DescriptionRunResultDTOToJSON,
  PaginatedDescriptionRunEventsDTOFromJSON,
  PaginatedDescriptionRunEventsDTOToJSON,
  PaginatedDescriptionRunsDTOFromJSON,
  PaginatedDescriptionRunsDTOToJSON,
  PlatformDescriptionStatusDTOFromJSON,
  PlatformDescriptionStatusDTOToJSON,
  ProductDescriptionSettingsDTOFromJSON,
  ProductDescriptionSettingsDTOToJSON,
  RegeneratedDescriptionDTOFromJSON,
  RegeneratedDescriptionDTOToJSON,
  ToggleProductDescriptionEnabledDTOFromJSON,
  ToggleProductDescriptionEnabledDTOToJSON
} from "../models";

export interface GetDescriptionRunByIdRequest {
  runId: number;
}

export interface GetDescriptionRunEventsRequest {
  runId: number;
  limit?: number;
  offset?: number;
  action?: GetDescriptionRunEventsActionEnum;
}

export interface ListDescriptionRunsRequest {
  limit?: number;
  offset?: number;
  status?: ListDescriptionRunsStatusEnum;
  platformId?: number;
}

export interface RegenerateForProductRequest {
  productId: number;
  force?: boolean;
}

export interface RunGenerationRequest {
  limit?: number;
  platformId?: number;
}

export interface SetDescriptionPlatformEnabledRequest {
  platformId: number;
  toggleProductDescriptionEnabledDTO: ToggleProductDescriptionEnabledDTO;
}

export interface UpdateDescriptionSettingsRequest {
  productDescriptionSettingsDTO: ProductDescriptionSettingsDTO;
}

/**
 *
 */
export class ProductDescriptionsApi extends runtime.BaseAPI {
  /**
   */
  async getDescriptionPlatformStatusesRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<PlatformDescriptionStatusDTO>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/productDescription/platforms`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PlatformDescriptionStatusDTOFromJSON));
  }

  /**
   */
  async getDescriptionPlatformStatuses(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<PlatformDescriptionStatusDTO>> {
    const response = await this.getDescriptionPlatformStatusesRaw(initOverrides);
    return await response.value();
  }

  /**
   */
  async getDescriptionRunByIdRaw(
    requestParameters: GetDescriptionRunByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<DescriptionRunResultDTO>> {
    if (requestParameters.runId === null || requestParameters.runId === undefined) {
      throw new runtime.RequiredError(
        "runId",
        "Required parameter requestParameters.runId was null or undefined when calling getDescriptionRunById."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/productDescription/runs/{runId}`.replace(
          `{${"runId"}}`,
          encodeURIComponent(String(requestParameters.runId))
        ),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => DescriptionRunResultDTOFromJSON(jsonValue));
  }

  /**
   */
  async getDescriptionRunById(
    requestParameters: GetDescriptionRunByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<DescriptionRunResultDTO> {
    const response = await this.getDescriptionRunByIdRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async getDescriptionRunEventsRaw(
    requestParameters: GetDescriptionRunEventsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedDescriptionRunEventsDTO>> {
    if (requestParameters.runId === null || requestParameters.runId === undefined) {
      throw new runtime.RequiredError(
        "runId",
        "Required parameter requestParameters.runId was null or undefined when calling getDescriptionRunEvents."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.limit !== undefined) {
      queryParameters["limit"] = requestParameters.limit;
    }

    if (requestParameters.offset !== undefined) {
      queryParameters["offset"] = requestParameters.offset;
    }

    if (requestParameters.action !== undefined) {
      queryParameters["action"] = requestParameters.action;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/productDescription/runs/{runId}/events`.replace(
          `{${"runId"}}`,
          encodeURIComponent(String(requestParameters.runId))
        ),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDescriptionRunEventsDTOFromJSON(jsonValue));
  }

  /**
   */
  async getDescriptionRunEvents(
    requestParameters: GetDescriptionRunEventsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedDescriptionRunEventsDTO> {
    const response = await this.getDescriptionRunEventsRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async getDescriptionSettingsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ProductDescriptionSettingsDTO>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/productDescription/settings`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => ProductDescriptionSettingsDTOFromJSON(jsonValue));
  }

  /**
   */
  async getDescriptionSettings(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ProductDescriptionSettingsDTO> {
    const response = await this.getDescriptionSettingsRaw(initOverrides);
    return await response.value();
  }

  /**
   */
  async listDescriptionRunsRaw(
    requestParameters: ListDescriptionRunsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedDescriptionRunsDTO>> {
    const queryParameters: any = {};

    if (requestParameters.limit !== undefined) {
      queryParameters["limit"] = requestParameters.limit;
    }

    if (requestParameters.offset !== undefined) {
      queryParameters["offset"] = requestParameters.offset;
    }

    if (requestParameters.status !== undefined) {
      queryParameters["status"] = requestParameters.status;
    }

    if (requestParameters.platformId !== undefined) {
      queryParameters["platformId"] = requestParameters.platformId;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/productDescription/runs`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDescriptionRunsDTOFromJSON(jsonValue));
  }

  /**
   */
  async listDescriptionRuns(
    requestParameters: ListDescriptionRunsRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedDescriptionRunsDTO> {
    const response = await this.listDescriptionRunsRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async regenerateForProductRaw(
    requestParameters: RegenerateForProductRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RegeneratedDescriptionDTO>> {
    if (requestParameters.productId === null || requestParameters.productId === undefined) {
      throw new runtime.RequiredError(
        "productId",
        "Required parameter requestParameters.productId was null or undefined when calling regenerateForProduct."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.force !== undefined) {
      queryParameters["force"] = requestParameters.force;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/productDescription/products/{productId}/regenerate`.replace(
          `{${"productId"}}`,
          encodeURIComponent(String(requestParameters.productId))
        ),
        method: "POST",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => RegeneratedDescriptionDTOFromJSON(jsonValue));
  }

  /**
   */
  async regenerateForProduct(
    requestParameters: RegenerateForProductRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RegeneratedDescriptionDTO> {
    const response = await this.regenerateForProductRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async runGenerationRaw(
    requestParameters: RunGenerationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<DescriptionRunResultDTO>>> {
    const queryParameters: any = {};

    if (requestParameters.limit !== undefined) {
      queryParameters["limit"] = requestParameters.limit;
    }

    if (requestParameters.platformId !== undefined) {
      queryParameters["platformId"] = requestParameters.platformId;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/productDescription/run`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DescriptionRunResultDTOFromJSON));
  }

  /**
   */
  async runGeneration(
    requestParameters: RunGenerationRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<DescriptionRunResultDTO>> {
    const response = await this.runGenerationRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async setDescriptionPlatformEnabledRaw(
    requestParameters: SetDescriptionPlatformEnabledRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PlatformDescriptionStatusDTO>> {
    if (requestParameters.platformId === null || requestParameters.platformId === undefined) {
      throw new runtime.RequiredError(
        "platformId",
        "Required parameter requestParameters.platformId was null or undefined when calling setDescriptionPlatformEnabled."
      );
    }

    if (
      requestParameters.toggleProductDescriptionEnabledDTO === null ||
      requestParameters.toggleProductDescriptionEnabledDTO === undefined
    ) {
      throw new runtime.RequiredError(
        "toggleProductDescriptionEnabledDTO",
        "Required parameter requestParameters.toggleProductDescriptionEnabledDTO was null or undefined when calling setDescriptionPlatformEnabled."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/api/productDescription/platforms/{platformId}/enabled`.replace(
          `{${"platformId"}}`,
          encodeURIComponent(String(requestParameters.platformId))
        ),
        method: "PATCH",
        headers: headerParameters,
        query: queryParameters,
        body: ToggleProductDescriptionEnabledDTOToJSON(requestParameters.toggleProductDescriptionEnabledDTO)
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => PlatformDescriptionStatusDTOFromJSON(jsonValue));
  }

  /**
   */
  async setDescriptionPlatformEnabled(
    requestParameters: SetDescriptionPlatformEnabledRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PlatformDescriptionStatusDTO> {
    const response = await this.setDescriptionPlatformEnabledRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async updateDescriptionSettingsRaw(
    requestParameters: UpdateDescriptionSettingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ProductDescriptionSettingsDTO>> {
    if (
      requestParameters.productDescriptionSettingsDTO === null ||
      requestParameters.productDescriptionSettingsDTO === undefined
    ) {
      throw new runtime.RequiredError(
        "productDescriptionSettingsDTO",
        "Required parameter requestParameters.productDescriptionSettingsDTO was null or undefined when calling updateDescriptionSettings."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/api/productDescription/settings`,
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: ProductDescriptionSettingsDTOToJSON(requestParameters.productDescriptionSettingsDTO)
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => ProductDescriptionSettingsDTOFromJSON(jsonValue));
  }

  /**
   */
  async updateDescriptionSettings(
    requestParameters: UpdateDescriptionSettingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ProductDescriptionSettingsDTO> {
    const response = await this.updateDescriptionSettingsRaw(requestParameters, initOverrides);
    return await response.value();
  }
}

/**
 * @export
 */
export const GetDescriptionRunEventsActionEnum = {
  WRITTEN: "WRITTEN",
  SKIPPED: "SKIPPED",
  ERROR: "ERROR",
  CLAIMED_BY_HAND: "CLAIMED_BY_HAND",
  PRODUCT_GONE: "PRODUCT_GONE"
} as const;
export type GetDescriptionRunEventsActionEnum =
  typeof GetDescriptionRunEventsActionEnum[keyof typeof GetDescriptionRunEventsActionEnum];
/**
 * @export
 */
export const ListDescriptionRunsStatusEnum = {
  RUNNING: "RUNNING",
  SUCCESS: "SUCCESS",
  FAILED: "FAILED"
} as const;
export type ListDescriptionRunsStatusEnum =
  typeof ListDescriptionRunsStatusEnum[keyof typeof ListDescriptionRunsStatusEnum];
